import { Box, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ReactComponent as RightChevron } from '../assets/icons/RightChervon.svg';
import { colors } from '../styles/colors';
import { countries, linkBaseUrl } from '../constants/menuItems';
import Image from './Image';

interface MenuProps {
  children: any;
}

export const Layout = ({ children }: MenuProps) => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: colors.basics.white,
          borderColor: '#ddd',
          borderLeft: '0',
          padding: '1.25rem',
          height: '100%',
          minHeight: '600px',
          '& .right_icon ': {
            height: '10px',
            width: '10px',
          },
          // SubHeading css
          '& .side_ul': {
            padding: '0 0 30px 30px',
          },
          '& .li_title': {
            paddingTop: '20px',
          },
          '& li .bottom_title': {
            color: colors.basics.primary,
          },
          //For SubHeading arrow css
          '& ul li .bottom_title': {
            '& svg': {
              '& path': { fill: 'red' },
            },
            '&:hover': {
              textDecoration: 'underline',
            },
          },

          '& .main_heading>a': {
            '&:hover': {
              textDecoration: 'underline',
              color: colors.basics.primary,
              fontFamily: 'Raleway,sans-serif',
            },
          },

          '& .heading': { color: colors.basics.primary, fontSize: '20px', fontWeight: 400, mb: 2, mt: 1 },
          '& a': {
            textDecoration: 'none',
          },
          //Right heading css
          '& .heading_right>a': { '&:hover': { textDecoration: 'underline', color: '#303030' } },
          // LiComponent css
          '& ul': { '& li': { padding: '0 0 20px', '& a': { fontSize: '16px', color: '#303030' } } },
          '& ul li a': {
            '&:hover': {
              color: colors.basics.primary,
            },
          },
        }}
      >
        {children}
      </Box>
    </>
  );
};

export const Africa = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '&>ul': { display: 'flex' },
            '& .side_ul': {
              padding: '0 0 30px 30px',
              borderLeft: '1px solid #939293',
            },
            '& .first_ul': {
              padding: '10px 30px 30px 0',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Africa Destinations' />
            <Box display='flex' p='0 0 0'>
              <ul className='first_ul'>
                <Box mb='.950rem'>
                  <Typography variant='subtitle1'>With Tropical Sky</Typography>
                </Box>

                {countries.africa.map((country, i) => (
                  <LiComponent name={country} href={countries.africaHolidaysLinks[i]} key={i} />
                ))}
                <SubHeading text='All Tropical Sky Destinations' href={`${linkBaseUrl}africa-holidays`} />
              </ul>
              <ul className='side_ul'>
                <Box mb='.800rem' mt={1}>
                  <Box className='heading_right'>
                    <a href='https://www.africaskysafari.com/' target='_blank' rel='noreferrer'>
                      <Typography variant='subtitle1'>With Africa Sky</Typography>
                    </a>
                  </Box>
                  <Box>
                    <Image src={`${process.env.REACT_APP_REDIRECT_URL}FrontEndGlobalAssets/dist/img/brands/africasky.svg`}
                      alt='AfricaLogo'
                    />
                  </Box>
                  <Box mt={2} mb={2}>
                    <Typography variant='subtitle2' maxWidth='200px' fontSize='.85rem'>
                      To view our Africa destinations visit our specialist Africa Sky site here
                    </Typography>
                  </Box>
                </Box>
                <LiComponent name='Botswana' href='https://www.africaskysafari.com/botswana-safaris' />
                <LiComponent name='Zambia' href='https://www.africaskysafari.com/zambia-safaris' />
                <LiComponent name='Uganda' href='https://www.africaskysafari.com/uganda-safaris' />
                <LiComponent name='Zimbabwe' href='https://www.africaskysafari.com/zimbabwe-safaris' />
                <LiComponent name='Rwanda' href='https://www.africaskysafari.com/rwanda-safaris' />
                <LiComponent name='Victoria Falls' href='https://www.africaskysafari.com/victoria-falls' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};

export const Australia = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            height: '100%',
            '& ul': { listStyle: 'none' },
            '&>ul': { display: 'flex' },
            '& .heading': { color: colors.basics.primary, fontSize: '20px' },
            '& a': {
              textDecoration: 'none',
            },
            '& .first_ul': {
              padding: '0 20px 35px',

              '&:nth-of-type(1)': {
                paddingRight: '30px',
              },
              '&:nth-of-type(2)': {
                borderLeft: '1px solid #939292',
                borderRight: '1px solid #939292',
              },
            },
          }}
        >
          <Box>
            <Box display='flex' p='50px 0 0'>
              <Box display='flex' sx={{ '& img': { maxWidth: '140px' } }}>
                <ul className='first_ul'>
                  <Box mb='.625rem'>
                    <Typography variant='subtitle1'>With Tropical Sky</Typography>
                  </Box>

                  {countries.australia.map((country, i) => (
                    <LiComponent name={country} href={countries.australiaHolidaysLinks[i]} key={i} />
                  ))}
                </ul>
                <ul className='first_ul'>
                  <Box>
                    <Box className='heading_right'>
                      <a href='https://www.australiansky.co.uk/' target='_blank' rel='noreferrer'>
                        <Typography variant='subtitle1'>With Australian Sky</Typography>
                      </a>
                    </Box>

                    <Box mt={2}>
                      <a href='https://www.australiansky.co.uk/' target='_blank' rel='noreferrer'>
                        <Image src={`${process.env.REACT_APP_REDIRECT_URL}FrontEndGlobalAssets/dist/img/brands/australiansky.svg`}
                          alt='AustralianLogo'
                        />
                      </a>
                    </Box>
                    <Box mt={2}>
                      <Typography variant='subtitle2' maxWidth='210px' fontSize='.85rem'>
                        To view our Australia destinations visit our specialist Australian Sky site here
                      </Typography>
                    </Box>
                  </Box>
                </ul>
                <ul className='first_ul'>
                  <Box>
                    <Box className='heading_right'>
                      <a href='https://www.newzealandsky.co.uk/' target='_blank' rel='noreferrer'>
                        <Typography variant='subtitle1'>With New Zealand Sky</Typography>
                      </a>
                    </Box>
                    <Box mt={2}>
                      <a href='https://www.newzealandsky.co.uk/' target='_blank' rel='noreferrer'>
                        <Image
                          src={`${process.env.REACT_APP_REDIRECT_URL}FrontEndGlobalAssets/dist/img/brands/newzealandsky.svg`}
                          alt='NewZealandLogo'
                        />
                      </a>
                    </Box>
                    <Box mt={2}>
                      <Typography variant='subtitle2' maxWidth='210px' fontSize='.85rem'>
                        To view our New Zealand destinations visit our specialist New Zealand Sky site here
                      </Typography>
                    </Box>
                  </Box>
                </ul>
              </Box>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};

export const Caribbean = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '&>ul': { display: 'flex' },
            '& .heading': { color: colors.basics.primary, fontSize: '20px' },
            '& a': {
              textDecoration: 'none',
            },
            '& .first_ul': {
              padding: '0 30px 0 0',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Caribbean Destinations' />
            <Box display='flex' p='10px 0 0'>
              <ul className='first_ul'>
                <Grid container>
                  {countries.caribbean.map((country, i) => (
                    <Grid item xs={6} key={i}>
                      <LiComponent name={country} href={countries.caribbeanHolidaysLinks[i]} />
                    </Grid>
                  ))}
                </Grid>
                <SubHeading text='All Caribbean Destinations ' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};

export const Dubai = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '&>ul': { display: 'flex' },
            '& .heading': { color: colors.basics.primary, fontSize: '20px' },
            '& a': {
              textDecoration: 'none',
            },
            '& .first_ul': {
              padding: '10px 30px 30px 0',
              flex: '0 0 50%',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Dubai & Middle East Destinations' />
            <Box display='flex' p='5px 0 0'>
              <ul className='first_ul'>
                {countries.middleEast.map((country, i) => (
                  <LiComponent name={country} href={countries.middleEastHolidaysLinks[i]} key={i} />
                ))}
                <SubHeading text='All Dubai & Middle East Destinations' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};

export const Europe = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '&>ul': { display: 'flex' },
            '& .heading': { color: colors.basics.primary, fontSize: '20px' },
            '& a': {
              textDecoration: 'none',
            },

            '& .first_ul': {
              padding: '0 30px 0 0',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Europe Destinations' />
            <Box display='flex' padding='0 0 0'>
              <ul className='first_ul'>
                <Grid container>
                  {countries.europe.map((country, i) => (
                    <Grid item xs={6} key={i}>
                      <LiComponent name={country} href={countries.europeHolidaysLinks[i]} />
                    </Grid>
                  ))}
                </Grid>
                <SubHeading text='All Europe Destinations ' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};

export const EastAsia = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '&>ul': { display: 'flex' },
            '& .heading': { color: colors.basics.primary, fontSize: '20px' },
            '& a': {
              textDecoration: 'none',
            },
            '& .first_ul': {
              padding: '10px 30px 30px 0',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Far East & Asia Destinations' />
            <Box display='flex' p='5px 0 0'>
              <ul className='first_ul'>
                <Grid container>
                  {countries.farEast.map((country, i) => (
                    <Grid item xs={6} key={i}>
                      <LiComponent name={country} href={countries.farEastHolidaysLinks[i]} />
                    </Grid>
                  ))}
                </Grid>
                <SubHeading text='All Far East & Asia Destinations' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};

export const IndiaOcean = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '&>ul': { display: 'flex' },
            '& .heading': { color: colors.basics.primary, fontSize: '20px' },
            '& a': {
              textDecoration: 'none',
            },
            '& .first_ul': {
              padding: '10px 30px 30px 0',
              flex: '0 0 50%',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Indian Ocean Destinations' />
            <Box display='flex' p='5px 0 0'>
              <ul className='first_ul'>
                {countries.indiaOcean.map((country, i) => (
                  <LiComponent name={country} href={countries.indianOceanHolidaysLinks[i]} key={i} />
                ))}
                <SubHeading text='All Indian Ocean Destinations' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};

export const NorthAmerica = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            height: '100%',
            '& ul': { listStyle: 'none' },
            '&>ul': { display: 'flex' },
            '& .heading': { color: colors.basics.primary, fontSize: '20px' },
            '& a': {
              textDecoration: 'none',
            },
            '& .first_ul': {
              position: 'relative',
              '&:nth-of-type(1)': {
                '&>.MuiBox-root': {
                  padding: '0 18px 0 30px',
                },
                '&:after': {
                  content: '""',
                  width: '1px',
                  height: '292px',
                  backgroundColor: '#939292',
                  position: 'absolute',
                  top: 0,
                },
              },
              '&:nth-of-type(2)': {
                borderLeft: '1px solid #939292',
                padding: '0 18px 0 30px',
                height: '190px',
              },
            },
          }}
        >
          <Box>
            <Box pt='50px' display='flex'>
              <Box display='flex' sx={{ '& img': { maxWidth: '140px' } }}>
                <ul className='first_ul'>
                  <Box>
                    <Box className='heading_right'>
                      <a href='https://www.americansky.co.uk/' target='_blank' rel='noreferrer'>
                        <Typography variant='subtitle1'>With American Sky</Typography>
                      </a>
                    </Box>
                    <Box mt={2}>
                      <a href='https://www.americansky.co.uk/' target='_blank' rel='noreferrer'>
                        <Image
                          src={`${process.env.REACT_APP_REDIRECT_URL}FrontEndGlobalAssets/dist/img/brands/americansky.svg`}
                          alt='AmericanLogo'
                        />
                      </a>
                    </Box>
                    <Box mt={2} mb={2}>
                      <Typography variant='subtitle2' maxWidth='210px' fontSize='.85rem'>
                        To view our USA destinations visit our specialist American Sky site here
                      </Typography>
                    </Box>
                    <LiComponent name='Florida' href='https://www.americansky.co.uk/florida-holidays' />
                    <LiComponent name='Hawaii' href='https://www.americansky.co.uk/hawaii-holidays' />
                  </Box>
                </ul>
                <ul className='first_ul'>
                  <Box>
                    <Box className='heading_right'>
                      <a href='https://www.canadiansky.co.uk/' target='_blank' rel='noreferrer'>
                        <Typography variant='subtitle1'>With Canadian Sky</Typography>
                      </a>
                    </Box>
                    <Box mt={2}>
                      <a href='https://www.canadiansky.co.uk/' target='_blank' rel='noreferrer'>
                        <Image
                          src={`${process.env.REACT_APP_REDIRECT_URL}FrontEndGlobalAssets/dist/img/brands/canadiansky.svg`}
                          alt='CanadianLogo'
                        /> </a>
                    </Box>
                    <Box mt={2}>
                      <Typography variant='subtitle2' maxWidth='210px' fontSize='.85rem'>
                        To view our Canada destinations visit our specialist Canadian Sky site here
                      </Typography>
                    </Box>
                  </Box>
                </ul>
              </Box>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};

export const Polar = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '&>ul': { display: 'flex' },
            '& .heading': { color: colors.basics.primary, fontSize: '20px' },
            '& a': {
              textDecoration: 'none',
            },
            '& .first_ul': {
              padding: '10px 30px 30px 0',
              flex: '0 0 50%',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='Polar Destinations' />
            <Box display='flex' padding='5px 0 0'>
              <ul className='first_ul'>
                {countries.polar.map((country, i) => (
                  <LiComponent name={country} href={countries.polarHolidaysLinks[i]} key={i} />
                ))}
                <SubHeading text='All Polar Destinations' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};

export const South = () => {
  return (
    <>
      <Layout>
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '&>ul': { display: 'flex' },
            '& .heading': { color: colors.basics.primary, fontSize: '20px' },
            '& a': {
              textDecoration: 'none',
            },
            '& .first_ul': {
              padding: '10px 30px 30px 0',
              flex: '0 0 50%',
            },
          }}
        >
          <Box className='main_heading'>
            <MainHeading text='South & Central America Destinations' />
            <Box display='flex' p='5px 0 0'>
              <ul className='first_ul'>
                {countries.southCentralAmerica.map((country, i) => (
                  <LiComponent name={country} href={countries.southCentralAmericaHolidaysLinks[i]} key={i} />
                ))}
                <SubHeading text='All South & Central America Destinations' />
              </ul>
            </Box>
          </Box>
        </Box>
      </Layout>
    </>
  );
};

export const MainHeading = (props: any) => {
  const { text } = props;
  return (
    <Link to='/'>
      <Typography variant='subtitle1' className='heading '>
        {text}
      </Typography>
    </Link>
  );
};

export const SubHeading = (props: any) => {
  const { text, href } = props;
  return (
    <li className='li_title'>
      <a href={href} target='_blank' rel='noreferrer' className='bottom_title'>
        {text}
        <RightChevron className='right_icon' />
      </a>
    </li>
  );
};

export const LiComponent = (props: any) => {
  const { name, link, href } = props;
  return (
    <li>
      {href ? (
        <a href={href} target='_blank' rel='noreferrer'>
          {name}
        </a>
      ) : (
        <Link to={link}>{name}</Link>
      )}
    </li>
  );
};
